import _sfc_main from "./TypesenseSearchResult.vue2.js";
import "./TypesenseSearchResult.vue3.js";
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const TypesenseSearchResult = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-107097ae"]]);
export {
  TypesenseSearchResult as default
};
//# sourceMappingURL=TypesenseSearchResult.vue.js.map
